import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Button, Breadcrumb, Confirm } from 'semantic-ui-react'
import { MainBodyContent } from 'components'
import { ProcurementContainer, ProcurementBody } from 'routes/ProcurementSystem/styled'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { ShortListEditContainer } from './styled'
import { shortListPath, shortListDetailPath } from 'routes'
import ShortListPart from '../Forms/ShortListPart'
import { getShortListDetail, updateShortList, clearFormData, deleteShortList } from 'ducks/shortList'
import SubmitForm from '../Forms/SubmitForm'
import { validateGeneralForm, validateVendorForm } from '../attributeData'

// import r from 'reactotron-react-js'

const ShortListEdit = (props) => {
  const { valueForm, change, updateShortList, history, username, isDetail = false } = props
  const [isSubmit, setIsSubmit] = useState(false)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)

  useEffect(() => {
    props.getShortListDetail(props.match.params.id, props.history)

    return () => {
      props.clearFormData()
    }
  }, [])

  useEffect(() => {
    const { status, sn } = valueForm
    if (status !== 0 && status !== undefined && status !== null) {
      if (sn === undefined || sn === null || sn === '') {
        history.push(shortListDetailPath(props.match.params.id))
      }
    } else {
      if (status === 0 && username.toLowerCase() !== valueForm.createdBy.toLowerCase()) {
        history.push(shortListDetailPath(props.match.params.id))
      }
    }
  }, [valueForm.status])

  const onSubmitEditForm = (values) => {
    var errors = validateGeneralForm(values, {})

    if (!isSubmit) {
      var vendors = values.vendors || []
      errors = validateVendorForm(vendors, errors)
    }

    if (Object.keys(errors).length) {
      scrollToFirstValidateFailElement(errors)
      throw new SubmissionError(errors)
    } else {
      updateShortList(values, isSubmit, history)
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle={`Short List - ${valueForm.documentNumber || 'Edit'}`}
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'SL', content: 'Short List', link: true, onClick: () => props.history.push(shortListPath) },
              { key: 'SLCreate', content: valueForm.documentNumber || 'Edit', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <ProcurementContainer>
        <ProcurementBody>
          <ShortListEditContainer>
            <form onSubmit={props.handleSubmit((values) => onSubmitEditForm(values))}>
              <ShortListPart valueForm={valueForm} change={change} isDetail={isDetail} />
              {
                valueForm.status === 0 ? 
                  <div className='btnContainer'>
                    <div className='left'>
                      <Button
                        type='button'
                        content='Delete'
                        icon='trash'
                        color='red'
                        labelPosition='left'
                        style={{ marginRight: '5px' }}
                        onClick={() => setShowDeleteConfirm(true)}
                      />
                    </div>
                    <div className='right'>
                      <Button
                        type='submit'
                        content='Save'
                        icon='save'
                        labelPosition='right'
                        style={{ marginRight: '5px' }}
                        onClick={() => setIsSubmit(false)}
                      />
                      <Button
                        type='submit'
                        content='Save & Submit'
                        color='blue'
                        icon='save'
                        labelPosition='right'
                        style={{ marginRight: '5px' }}
                        onClick={() => setIsSubmit(true)}
                      />
                    </div>
                  </div> :
                  <div className='btnContainer'>
                    { valueForm.sn ? <SubmitForm valueForm={valueForm} change={change} handleSubmit={props.handleSubmit} history={props.history} /> : null }
                  </div>
              }
              
            </form>
          </ShortListEditContainer>
          <Confirm
            open={showDeleteConfirm}
            cancelButton='Cancel'
            confirmButton='Delete'
            header='Short List'
            content='Do you want to delete document?'
            onCancel={() => setShowDeleteConfirm(false)}
            onConfirm={() => {
              setShowDeleteConfirm(false)
              props.deleteShortList(valueForm.id, props.history)
            }}
          />
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => {
  const vf = getFormValues('formShortList')(state) || {}
  const sl = state.shortList.shortList.data
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : '' 
  
  return ({
    username,
    valueForm: vf,
    shortList: sl,
    initialValues: {
      id: sl.id,
      status: sl.status,
      statusActivity: sl.statusActivity,
      title: vf.title || sl.title || null,
      documentDate: vf.documentDate || sl.documentDate || null,
      documentNumber: vf.documentNumber || sl.documentNumber || null,
      companyCode: vf.companyCode || sl.companyCode || null,
      typeOfTender: vf.typeOfTender || sl.typeOfTender || null,
      works: vf.works || sl.works || null,
      projectId: vf.projectId || sl.projectId || null,
      requesterUser: vf.requesterUser || sl.requesterUser || null,
      createdBy: vf.createdBy || sl.createdBy || null,
      effectiveDate: vf.effectiveDate || sl.effectiveDate || null,
      draftBudget: vf.draftBudget || sl.draftBudget || null,
      projectStartTime: vf.projectStartTime || sl.projectStartTime || null,
      projectEndTime: vf.projectEndTime || sl.projectEndTime || null,
      remark: vf.remark || sl.remark || null,
      vendors: vf.vendors || sl.vendors || null,
      pqs: vf.pqs || sl.pqs || null,
      committees: vf.committees || sl.committees || null,
      attachment01: vf.attachment01 || sl.attachment01 || null,
      sn: sl.sn,
      actions: sl.actions,
      SL01: vf.SL01 || null
    }
  })
}

const mapDispatchToProps = {
  getShortListDetail,
  updateShortList,
  clearFormData,
  deleteShortList
}

const ShortListEditForm = reduxForm({
  form: 'formShortList',
  enableReinitialize: true,
})(ShortListEdit)

export default connect(mapStateToProps, mapDispatchToProps)(ShortListEditForm)